require('angular')
require('angular-route')
require('angular-ui-map')

require('../../core/translation/translation-module')
require('../components/common-wrapper/common-wrapper-module')
require("../components/map/map-module")
require('../components/number/number-module')
require('../components/analyze-access/analyze-access-module')

require('./index.jade')

# Load Css
require('../../../sass/web/html/_club.scss')

ClubService = require('./club-service')
RoundInfoService = require('../score-registration/round-info/round-info-service')
ClubShowCtrl = require('./club-controller')
ClubMapCtrl = require('./club-map/club-map-controller')
ClubScoreCardCtrl = require('./club-scorecard/club-scorecard-controller')
ClubScoreCardDirective = require('./club-scorecard/club-scorecard-detail-directive')
ClubHoleByHoleCtrl = require('./club-hole-by-hole/club-hole-by-hole-controller')
ClubHoleByHoleDetailDirective = require('./club-hole-by-hole/club-hole-by-hole-detail-directive')
ClubHoleByHoleBarChartDirective = require('./club-hole-by-hole/club-hole-by-hole-bar-chart-directive')


modules = [
  'ngRoute'
  'gnp-translation'
  'gnp-common-wrapper'
  'gnp-remote-api'
  'gnp-map'
  'gnp-number'
  'gnp-analyze-access'
]
angular.module 'gnp-app-club', modules
  .config ['$routeProvider', '$translateProvider', ($routeProvider, $translateProvider) ->
    $translateProvider
      .translations 'en', require('./i18n/en')
      .translations 'ja', require('./i18n/ja')

    $routeProvider.when '/clubs/:id',
      controller: 'ClubShowCtrl'
      templateUrl: 'web/club/index.jade'
      resolve:
        clubInfo: ['ClubService', '$route', (ClubService, $route) ->
          ClubService.getClub($route.current.params.id, true)
        ]
        fromJapan: ['CountryAPIService', (CountryAPIService) ->
          CountryAPIService.fromJapan()
        ]
      title: '_CLUB_PAGE.PAGE_TITLE'
  ]
  .controller 'ClubShowCtrl', ClubShowCtrl
  .controller 'ClubMapCtrl', ClubMapCtrl
  .controller 'ClubScoreCardCtrl', ClubScoreCardCtrl
  .controller 'ClubHoleByHoleCtrl', ClubHoleByHoleCtrl
  .factory 'ClubService', ClubService
  .factory 'RoundInfoService', RoundInfoService
  .directive('clubScoreCard', ClubScoreCardDirective)
  .directive('clubHoleByHoleDetail', ClubHoleByHoleDetailDirective)
  .directive('clubHoleByHoleBarChart', ClubHoleByHoleBarChartDirective)



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/club/club-module.coffee